import type { Resource } from '../../';
export const product_sizeChart_measurements_centimeters: Resource = {"default":"cm"};
